// extracted by mini-css-extract-plugin
export default {"text":"FWAnDF","seat":"zyvKrY","mobile":"Wuv_jX","selected":"iF4L1x","wholeTableReservation":"HC1Tgf"};